// @flow

import { PaymentTypes } from '../model/props';

const map = {
  'Check update': 'Revisar actualización',
  'Privacy policy updated': 'HEMOS ACTUALIZADO NUESTROS TÉRMINOS Y CONDICIONES Y NUESTRA POLÍTICA DE PRIVACIDAD',
  'Accept mandatory terms':
    'Para proteger tus derechos, hemos realizado actualizaciones importantes. Te invitamos a revisar los cambios para seguir utilizando nuestro sistema con plena confianza y seguridad.',
  'Accept privacy policy': 'Aceptar política de privacidad(*)',
  'Accept marketing campaigns': 'Aceptar recibir comunicaciones de ofertas y campañas publicitarias(Opcional)',
  Reload: 'Recargar',
  'Final customer': 'Consumidor final',
  'Total price': 'Precio total',
  Container: 'Contenedor',
  'Sign container': 'Contenedor (Opcional)',
  'Enter your information': 'Registre su información',
  Name: 'Nombre',
  Lastname: 'Apellido(s)',
  Email: 'Correo electrónico',
  Password: 'Contraseña',
  Next: 'Siguiente',
  'Already a customer? Sign in': '¿Ya eres cliente? Ingresar',
  'Sign in': 'Ingresar',
  "Don't have an account? Sign Up": '¿No tienes cuenta? Crear cuenta',
  Required: 'Requerido',
  'Invalid email address': 'Correo electrónico no válido',
  'Invalid name': 'Nombre no válido',
  'Invalid lastname': 'Apellidos no válidos',
  'Invalid password':
    'La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial',
  Phone: 'Teléfono',
  Gender: 'Género',
  'Invalid phone': 'Teléfono no válido',
  Forbidden: 'Acceso prohibido',
  'Bad request': 'Solicitud no válida',
  'Upload RUC Document': 'Subir documento RUC',
  'Click to select RUC document': 'Haga clic para seleccionar el documento RUC',
  'Photo in JPG, PNG or PDF format': 'Foto en formato JPG, PNG o PDF',
  'Photo of tax registration': 'Documento tributario',
  'Upload RUC': 'Subir RUC',
  'Uploading RUC...': 'Subiendo RUC...',
  'Uploading...': 'Subiendo RUC...',
  'RUC document uploaded': 'Documento RUC subido',
  'Bad credentials': 'Credenciales incorrectas',
  'No content': 'Sin contenido.',
  'Sign out': 'Cerrar sesión',
  'Sign requests': 'Trámites',
  Profile: 'Perfil',
  'Request sign': 'Solicitar certificado',
  'Please select person type': 'Por favor seleccione tipo de persona',
  'Person type': 'Tipo de persona',
  'Natural person': 'Persona natural',
  'Natural person ruc': 'Persona natural con RUC',
  OK: 'Aceptar',
  Cancel: 'Cancelar',
  'Confirm to sign out': 'Confirme para cerrar sesión.',
  'Sign duration': 'Duración de certificado',
  Year: 'Año',
  Years: 'Años',
  Month: 'Mes',
  Months: 'Meses',
  Day: 'Día',
  Days: 'Días',
  Created: 'Creado',
  Duration: 'Duración',
  Price: 'Precio',
  Save: 'Guardar',
  'Personal data': 'Datos personales',
  'Not completed': 'Sin completar',
  Completed: 'Completado',
  'Legal ID type': 'Tipo de identificación',
  'Legal ID': 'Identificación',
  'Legal EC': 'Identificación Ecuatoriana',
  'Legal ID expires at': 'Expiración de Identificación',
  'ID Document Code': 'Código dactilar',
  Passport: 'Pasaporte',
  'Ec cedula': 'Cédula',
  'Ec ruc': 'RUC',
  Birthday: 'Fecha de nacimiento',
  'Province of birth': 'Provincia de nacimiento',
  'City of birth': 'Ciudad de nacimiento',
  'Data saved': 'Datos guardados',
  'Country of residence': 'País de residencia',
  'Country of birth': 'Nacionalidad',
  'Province of residence': 'Provincia de residencia',
  'City of residence': 'Ciudad de residencia',
  'Address of residence': 'Dirección de residencia',
  Country: 'País',
  Province: 'Provincia',
  City: 'Ciudad',
  Address: 'Dirección',
  'Documents data': 'Documentos',
  'Document LEGAL_ID': 'Documento de identificación (frente)',
  'Add document LEGAL_ID': 'Agregar documento de identificación (frente)',
  'Document LEGAL_ID_BACK': 'Documento de identificación (reverso)',
  'Add document LEGAL_ID_BACK': 'Agregar documento de identificación (reverso)',
  'Document BASIC_SERVICE_BILL': 'Factura de servicio básico',
  'Add document BASIC_SERVICE_BILL': 'Agregar factura de servicio básico',
  'Document EC_RUC': 'RUC',
  'Add document COMPANY_CONSTITUTION': 'Agregar escrituras de constitución',
  'Document COMPANY_CONSTITUTION': 'Escrituras de constitución',
  'Add document COMPANY_CUSTOMER_NOMINATION': 'Agregar nombramiento',
  'Document COMPANY_CUSTOMER_NOMINATION': 'Nombramiento',
  'Add document EC_RUC': 'Agregar RUC',
  Process: 'Procesar',
  'Document saved': 'Documento guardado',
  'Document removed': 'Documento eliminado',
  'Payment validated': 'Pago validado',
  'Process state changed': 'El estado del proceso ha cambiado',
  'Network Error': 'Error de conexión',
  'Your process is DRAFT': 'Complete todos los datos de su solicitud',
  'Your process is DATA_LOADED': 'Los datos personales han sido completados',
  'Your process is DOCUMENTS_LOADED': 'Los documentos de solicitud han sido completados',
  'Your process is BILLING_LOADED': 'Los datos de facturación han sido completados',
  'Your process is PAYMENT_LOADED': 'El pago ha sido efectuado',
  'Your process is AGREEMENT_LOADED': 'El acuerdo de contrato ha sido completado',
  'Your process is VIDEO_LOADED': 'Ha completado su solicitud, un agente le contactará para completar el proceso',
  'Your process is DATA_VALIDATED': 'Los datos han sido validados',
  'Your process is DOCUMENTS_VALIDATED': 'Los documentos han sido validados',
  'Your process is BILLING_VALIDATED': 'Los datos de facturación han sido validados',
  'Your process is PAYMENT_VALIDATED': 'El pago ha sido validado',
  'Your process is AGREEMENT_VALIDATED': 'El acuerdo de contrato ha sido validado',
  'Your process is VIDEO_VALIDATED': 'El video ha sido validado',
  'Your process is VENDOR_READY': 'En proceso...',
  'Your process is VENDOR_PROCESSING': 'En trámite con el proveedor',
  'Your process is CUSTOMER_ACTIVATED': 'Activado, pendiente de emisión',
  'Your process is VENDOR_COMPLETED': 'Trámite completado',
  'Your process is VENDOR_REJECTED': 'Trámite fallido',
  'Your process is REVOKED': 'Trámite revocado',
  'Your process is CANCELLED': 'Trámite cancelado',
  'Your process is REJECTED': 'Trámite rechazado',
  'Full name': 'Nombre completo',
  'Zip code': 'Código postal',
  'For invoicing': 'Para facturar',
  'For invoicing description': 'La firma ES para facturación electrónica',
  'Upload limit is MB_SIZE': 'El límite de carga de documentos es {{size}} MB',
  Unauthorized: 'No autorizado',
  'Legal person': 'Persona jurídica',
  'Company data': 'Datos de empresa',
  'Company rol': 'Cargo en la empresa',
  'Company name': 'Razón social',
  'Company ID': 'RUC',
  'Payment saved': 'Pago guardado',
  'Payment data': 'Datos de pago',
  Load: 'Cargar',
  Coupon: 'Cupón',
  'Apply coupon': 'Aplicar cupón',
  'Applied coupon': 'Cupón aplicado',
  'Load link': 'Cargar enlace',
  'Proof of payment': 'Comprobante de pago',
  'Contract agreement': 'Acuerdo de contrato',
  'Agreement intro':
    'Yo {{fullName}} con identificación {{legalID}} autorizo a ARN1 TOUWOLF TECHNOLOGIES la emisión de mi certificado digital de Firma Electrónica.',
  'Legal agreement intro':
    'Yo {{fullName}} con identificación {{legalID}} en mi calidad de representante legal de la empresa {{companyData.name}}, con número de RUC {{companyData.legalID}}, autorizo a Autoridad de Registro de Nivel 1 TOUWOLF TECHNOLOGIES S.A, la emisión de los siguientes certificados digitales para los siguientes empleados de esta empresa:',
  'Agreement tributary intro':
    'Yo {{fullName}} con identificación tributaria {{tributaryLegalID}} autorizo a ARN1 TOUWOLF TECHNOLOGIES la emisión de mi certificado digital de Firma Electrónica.',
  'Agreement sign use':
    'Uso Principal de la Firma: Firma de documentos (No es para facturación electrónica, se requiere copia del RUC)',
  'Tributary agreement sign use': 'Uso Principal de la Firma: Facturación electrónica',
  'Agreement intro 2':
    'Particular que pongo en su conocimiento para los fines pertinentes. Relaciono mis datos a continuación:',
  'Agreement acknowledge':
    'He revisado y verificado que los datos que constan en el presente documento son correctos, y estoy consciente que los mismos se utilizarán en mi firma electrónica, y que estos datos no podrán ser modificados una vez que se realice la emisión de mi firma electrónica.',
  'Agreement farewell': 'Atentamente',
  'Tributary Name': 'Nombre tributario',
  'Tributary Legal ID': 'Identificación tributaria',
  Clear: 'Limpiar',
  MALE: 'Masculino',
  FAMELE: 'Femenino',
  FEMALE: 'Femenino',
  'Sign the contract agreement please': 'Firme el acuerdo de contrato por favor.',
  'Verification video': 'Imagen de verificación',
  'Validation process': 'Proceso de validación',
  'Upload verification video': 'Subir imagen de verificación manual (LENTO)',
  'Check example': 'Ver ejemplo',
  'Video saved': 'Video guardado',
  'Verification saved': 'Verificación guardada',
  Validated: 'Validado',
  'See saved agreement': 'Ver contrato guardado',
  'Contract agreement saved': 'Contrato guardado.',
  'Payment type': 'Modo de pago',
  [PaymentTypes.TRANSFER]: 'Transferencia o depósito',
  [PaymentTypes.CREDIT]: 'Crédito',
  [PaymentTypes.CASH]: 'Efectivo',
  [PaymentTypes.PAYPHONE]: 'Pago con PayPhone',
  [PaymentTypes.CREDIT_CARD]: 'Tarjeta crédito',
  [PaymentTypes.DEUNA]: 'Pago con Deuna (PICHINCHA)',
  'Go to payment': 'Realizar el pago',
  'Payment verifying': 'Verificando pago',
  'Your payment is processing': 'Su pago está siendo procesado, puede cerrar esta ventana.',
  'Your validation is processing': 'Su validación está siendo procesada...',
  'Download template': 'Descargar plantilla',
  'Agreement terms accepted': 'Acepto los términos del contrato',
  'Upload agreement': 'Subir contrato firmado',
  'Upload Signed Contract': 'Subir contrato firmado',
  'Video intro': 'Debe leer en el video el siguiente texto',
  'Could not detect camera': 'No se pudo detectar la cámara. Verifique tener los permisos habilitados',
  'Take Picture': 'Tomar foto',
  'Clear Image': 'Quitar foto',
  'Send Image': 'Enviar foto',
  'Browse validation link': 'Ir al enlace para realizar la validación',
  'Browse validation qr': 'También puede escanear el QR desde su móvil:',
  'Browse selfie link': 'Ir al enlace para tomar la selfie',
  'Browse selfie qr': 'También puede escanear el QR desde su móvil:',
  'Validation already completed': 'Validación ya completada',
  'Validation Completed': 'Validación Completada',
  'Your selfie verification has been successfully completed':
    'Su verificación de selfie ha sido completada exitosamente',
  'Your identity validation has been successfully completed':
    'Su validación de identidad ha sido completada exitosamente',
  'Verified and Secure': 'Verificado y Seguro',

  //Deuna payment
  'Scan the QR code with the Deuna app to complete your payment':
    'Escanea el código QR con la app de Deuna para completar tu pago.',
  'Press the button to open the Deuna app and complete your payment':
    'Presiona el botón para abrir la app de Deuna y finalizar tu pago.',
  'Payment with Deuna': 'Pago con Deuna',

  // PayPhone translations
  'PayPhone Payment Verification': 'Verificación de Pago PayPhone',
  'EcuaFirma Payment Processing': 'Procesamiento de Pago EcuaFirma',
  'Payment Verification': 'Verificación de Pago',
  'Payment Successful!': '¡Pago Exitoso!',
  'Your PayPhone payment has been processed successfully': 'Su pago con PayPhone ha sido procesado exitosamente',
  'Payment Failed': 'Pago Fallido',
  'There was an issue processing your PayPhone payment': 'Hubo un problema procesando su pago con PayPhone',
  'Payment Processing': 'Procesando Pago',
  'Your PayPhone payment is being verified. Please wait...':
    'Su pago con PayPhone está siendo verificado. Por favor espere...',
  'Checking Payment Status': 'Verificando Estado del Pago',
  'Please wait while we verify your PayPhone payment': 'Por favor espere mientras verificamos su pago con PayPhone',
  'Attempt {{count}} of 10': 'Intento {{count}} de 10',
  'Transaction Details': 'Detalles de la Transacción',
  'Payment ID': 'ID de Pago',
  'Transaction ID': 'ID de Transacción',
  Amount: 'Monto',
  Status: 'Estado',
  Retry: 'Reintentar',
  Continue: 'Continuar',
  'Go Back': 'Volver',

  // Credit Card and PayPhone payment section translations
  'Credit Card Payment': 'Pago con Tarjeta de Crédito',
  'Secure payment processing powered by Stripe': 'Procesamiento seguro de pagos con Stripe',
  'Total amount to pay': 'Monto total a pagar',
  'Secured by 256-bit SSL encryption': 'Protegido con encriptación SSL de 256 bits',
  'Loading secure payment link...': 'Cargando enlace de pago seguro...',
  'Click below to generate your secure payment link': 'Haga clic abajo para generar su enlace de pago seguro',
  'Generate Payment Link': 'Generar Enlace de Pago',
  'Ready to pay!': '¡Listo para pagar!',
  "You will be redirected to Stripe's secure payment page to complete your transaction safely":
    'Será redirigido a la página segura de Stripe para completar su transacción de forma segura',
  'Pay with Stripe': 'Pagar con Stripe',
  'Your payment information is protected by industry-standard security':
    'Su información de pago está protegida con seguridad estándar de la industria',
  'PayPhone Payment': 'Pago con PayPhone',
  'Fast and secure mobile payment solution for Ecuador': 'Solución de pago móvil rápida y segura para Ecuador',
  'Secure payments in Ecuador': 'Pagos seguros en Ecuador',
  'Loading PayPhone payment option...': 'Cargando opción de pago PayPhone...',
  'Click below to generate your PayPhone payment option': 'Haga clic abajo para generar su opción de pago PayPhone',
  'Generate PayPhone Payment': 'Generar Pago PayPhone',
  'Ready to pay with PayPhone!': '¡Listo para pagar con PayPhone!',
  'Payment processed securely through PayPhone Ecuador': 'Pago procesado de forma segura a través de PayPhone Ecuador',
  'Click the refresh button to try again': 'Haga clic en el botón de actualizar para intentar de nuevo',

  // Stepper steps
  'Basic Information': 'Información básica',
  Identification: 'Identificación',
  'Personal Details': 'Detalles personales',

  // Document section
  'Uploaded Documents': 'Documentos subidos',
  'Required Documents': 'Documentos requeridos',

  // Payment section
  'Billing Information': 'Información de facturación',
  'Transfer Information': 'Información de transferencia',
  'Bank Details': 'Datos bancarios',
  'Transfer Details': 'Detalles de transferencia',
  'Bank Code': 'Código de banco',
  'Copy bank code': 'Copiar código de banco',
  'Copy target name': 'Copiar nombre del beneficiario',
  'Copy legal ID': 'Copiar identificación',
  'Copy email': 'Copiar correo electrónico',
  'Copy address': 'Copiar dirección',
  'Copy phone number': 'Copiar número de teléfono',
  'Copied to clipboard': 'Copiado al portapapeles',
  'Bank code copied to clipboard': 'Código de banco copiado',
  'Target name copied to clipboard': 'Nombre del beneficiario copiado',
  'Legal ID copied to clipboard': 'Identificación copiada',
  'Email copied to clipboard': 'Correo electrónico copiado',
  'Phone number copied to clipboard': 'Teléfono copiado',
  'Address copied to clipboard': 'Dirección copiada',
  'Select payment method': 'Seleccione método de pago',
  'Target to': 'Beneficiario',
  Upload: 'Subir',
  Refresh: 'Actualizar',
  'Upload proof of payment': 'Subir comprobante de pago',

  // Headers and titles
  'Document and Personal Data Validation': 'Validación de documentos y datos personales',
  'EcuaFirma Digital Signature Process': 'Proceso de firma digital EcuaFirma',
  'Powered by eQon': 'Desarrollado por eQon',

  // Actions and buttons
  Back: 'Atrás',

  // ProcessAgreementData specific translations
  'Accept terms and conditions': 'Acepto los términos y condiciones',
  'Download Signed Agreement': 'Descargar Acuerdo Firmado',
  'Agreement successfully signed': 'Acuerdo firmado exitosamente',
  'Update Signature': 'Actualizar Firma',
  'Legal Entity Information': 'Información de Entidad Legal',
  'Company Information': 'Información de la Empresa',
  'R.U.C.': 'R.U.C.',
  'Legal representative full name': 'Nombre completo del representante legal',
  'Signing Authority': 'Autoridad de Firma',
  'Name of people who will use a sign': 'Nombre de la persona que utilizará la firma',
  Role: 'Cargo',
  'Company Address Details': 'Detalles de Dirección de la Empresa',
  'RUC address': 'Dirección del RUC',
  'Valid company email': 'Correo electrónico válido de la empresa',
  'Company phone': 'Teléfono de la empresa',
  'Legal agreement note': 'Nota del acuerdo legal',
  'Processing agreement...': 'Procesando acuerdo...',
  'Agreement client page': 'Página de cliente del acuerdo',
  'Agreement client page description': 'Descripción de la página de cliente del acuerdo',
  'Choose Your Signing Method': 'Elija Su Método de Firma',
  'Select how you would like to complete your agreement signature':
    'Seleccione cómo desea completar la firma de su acuerdo',
  'Already have a signed PDF': 'Ya tiene un PDF firmado',
  'Digital Signature': 'Firma Digital',
  'Sign electronically now': 'Firme electrónicamente ahora',
  'Upload Your Signed Contract': 'Suba Su Contrato Firmado',
  'Upload a PDF file with your signature already applied': 'Suba un archivo PDF con su firma ya aplicada',
  'Download the template agreement': 'Descargar la plantilla del acuerdo',
  'Print and sign the downloaded template, then scan or photograph it as a PDF':
    'Imprima y firme la plantilla descargada, luego escanéela o fotográfela como PDF',
  'Upload your signed document': 'Suba su documento firmado',
  'Click to select your signed PDF': 'Haga clic para seleccionar su PDF firmado',
  'Maximum file size': 'Tamaño máximo de archivo',
  'File selected successfully': 'Archivo seleccionado exitosamente',
  'Update Signed Contract': 'Actualizar Contrato Firmado',
  'Remove File': 'Quitar Archivo',
  'Create Digital Signature': 'Crear Firma Digital',
  'Sign electronically using your mouse, trackpad, or touch screen':
    'Firme electrónicamente usando su mouse, trackpad o pantalla táctil',
  'Create your signature': 'Cree su firma',
  'Use your mouse, trackpad, or finger to sign in the box below':
    'Use su mouse, trackpad o dedo para firmar en el cuadro de abajo',
  'Please create your signature first': 'Por favor cree su firma primero',
  'Update Digital Signature': 'Actualizar Firma Digital',
  'Save Digital Signature': 'Guardar Firma Digital',
  'Clear Signature': 'Limpiar Firma',
  'Signature will be applied to': 'La firma se aplicará a',
  Signatory: 'Firmante',
  'This signature will be legally associated with the above name':
    'Esta firma se asociará legalmente con el nombre anterior',
  'You are updating your existing signature':
    'Está actualizando su firma existente. La nueva firma reemplazará a la actual.',

  // ProcessBillingData specific translations
  'Billing data': 'Datos de facturación',
  'My personal data': 'Mis datos personales',
  'Same billing and personal data': 'Mismos datos personales y de facturación',
  'Use my personal information for billing': 'Usar mi información personal para facturación',
  'Bill to a different entity': 'Facturar a una entidad diferente',

  // Status translations
  'Billing data completed': 'Datos de facturación completados',
  'Billing data not completed': 'Datos de facturación no completados',
  'Billing data validated': 'Datos de facturación validados',
  'Billing data saved': 'Datos de facturación guardados',

  // Section headers
  'Personal Information': 'Información Personal',
  'Contact Information': 'Información de Contacto',
  'Identification Information': 'Información de Identificación',
  'Address Information': 'Información de Dirección',

  // ProcessVideoData specific translations
  'Terms and Conditions': 'Términos y Condiciones',
  'Please accept our terms to proceed with validation':
    'Por favor acepte nuestros términos para proceder con la validación',
  'Secure identity verification process': 'Proceso seguro de verificación de identidad',
  'Selfie Verification': 'Verificación de Selfie',
  'Selfie intro':
    'Tome una selfie sosteniendo su documento de identidad junto a su rostro, asegúrese de que ambos sean claramente visibles.',
  'Image intro': 'La imagen debe ser clara y bien iluminada. Su rostro y documento deben estar completamente visibles.',
  'Selfie Verification Link': 'Enlace de Verificación de Selfie',
  'Use the link or QR code to complete your selfie verification':
    'Use el enlace o código QR para completar su verificación de selfie',
  'Scan QR code with mobile': 'Escanear código QR con móvil',
  'Or access verification link': 'O acceder al enlace de verificación',
  'Scan with your mobile device': 'Escanee con su dispositivo móvil',
  'Validation Ready': 'Validación Lista',
  'Use the link or scan the QR code to complete validation':
    'Use el enlace o escanee el código QR para completar la validación',
  'Loading validation data...': 'Cargando datos de validación...',
  'Take your selfie': 'Tome su selfie',
  'Position your face in the center of the camera': 'Posicione su rostro en el centro de la cámara',

  // Continue Process translations
  'Ready to continue?': '¿Listo para continuar?',
  'Complete your digital signature process in the next step':
    'Complete su proceso de firma digital en el siguiente paso',
  'Continue Process': 'Continuar Proceso',

  // Support translations
  'Need agent assistance?': '¿Necesita asistencia de un agente?',
  'Contact Agent via WhatsApp': 'Contactar Agente por WhatsApp',
  'Agent support text':
    'Hola, necesito asistencia con mi proceso de firma digital. Mi nombre es {{fullName}} y mi correo es {{email}}.',
  'Need technical support?': '¿Necesita soporte técnico?',
  'Contact Support via WhatsApp': 'Contactar Soporte por WhatsApp',
  'Support text':
    'Hola, necesito soporte técnico con mi proceso de firma digital. Mi nombre es {{fullName}} y mi correo es {{email}}.',

  // Payment Renewal specific translations
  'Payment Renewal Validation': 'Validación de Renovación de Pago',
  'EcuaFirma Digital Signature Renewal Process': 'Proceso de Renovación de Firma Digital EcuaFirma',
  'Payment renewal data saved': 'Datos de renovación de pago guardados',
  'Renewal coupon applied': 'Cupón de renovación aplicado',
  'Billing data for renewal saved': 'Datos de facturación para renovación guardados',
  'Ready to renew?': '¿Listo para renovar?',
  'Complete your digital signature renewal process in the next step':
    'Complete su proceso de renovación de firma digital en el siguiente paso',
  'Continue Renewal Process': 'Continuar Proceso de Renovación',
  'Agent renewal support text':
    'Hola, necesito asistencia con mi proceso de renovación de firma digital. Mi nombre es {{fullName}} y mi correo es {{email}}.',
  'Contact Agent for Renewal via WhatsApp': 'Contactar Agente para Renovación por WhatsApp',
  'Renewal support text':
    'Hola, necesito soporte técnico con mi proceso de renovación de firma digital. Mi nombre es {{fullName}} y mi correo es {{email}}.',
  'Contact Renewal Support via WhatsApp': 'Contactar Soporte de Renovación por WhatsApp',

  // Enhanced Payment Verification translations
  'Payment Under Verification': 'Pago en Verificación',
  'We are currently reviewing your payment proof': 'Actualmente estamos revisando su comprobante de pago.',
  Processing: 'Procesando',
  'What happens next?': '¿Qué sigue?',
  'Review in Progress': 'Revisión en Progreso',
  'Our team is validating your payment information': 'Nuestro equipo está validando su información de pago',
  'Email Notification': 'Notificación por Correo',
  'You will receive an email once verification is complete':
    'Recibirá un correo electrónico una vez que se complete la verificación',
  'Process Activation': 'Activación del Proceso',
  'Your service will be activated upon successful verification':
    'Su servicio se activará una vez que la verificación sea exitosa',
  'Payment Successfully Validated': 'Pago Validado Exitosamente',
  'Your payment has been confirmed and verified':
    'Su pago ha sido confirmado y verificado. Su servicio está ahora activo.',
  Verified: 'Verificado',
  'Service Status': 'Estado del Servicio',
  'Payment Confirmed': 'Pago Confirmado',
  'Your payment has been successfully processed and validated': 'Su pago ha sido procesado y validado exitosamente',
  'Service Activated': 'Servicio Activado',
  'All features are now available for your use': 'Todas las características están ahora disponibles para su uso',
  'Secure & Protected': 'Seguro y Protegido',
  'Your transaction is secured with industry-standard encryption':
    'Su transacción está asegurada con encriptación estándar de la industria',
  'Validation Pending': 'Validación Pendiente',
  'Your selfie verification has been Pending': 'Su verificación de selfie está pendiente',
  'Your identity validation has been Pending': 'Su validación de identidad está pendiente',

  // ProcessAgreementData additional translations
  'Agreement Validated': 'Acuerdo Validado',
  'Your contract agreement has been successfully validated and approved':
    'Su acuerdo contractual ha sido validado y aprobado exitosamente',

  // Contract Agreement Status translations
  'Contract Agreement Pending': 'Acuerdo de Contrato Pendiente',
  'Your contract agreement is currently under review': 'Su acuerdo de contrato está actualmente bajo revisión',
  'Pending Review': 'Revisión Pendiente',
  'Contract Agreement Rejected': 'Acuerdo de Contrato Rechazado',
  'Your contract agreement has been rejected':
    'Su acuerdo de contrato ha sido rechazado. Por favor contacte soporte para más información',
  Rejected: 'Rechazado',
  'Contract Agreement Approved': 'Acuerdo de Contrato Aprobado',
  'Your contract agreement has been successfully approved and processed':
    'Su acuerdo de contrato ha sido aprobado y procesado exitosamente',
  Approved: 'Aprobado',

  // Duration Change functionality
  'Want to change duration?': '¿Desea cambiar la duración?',
  'Change Duration': 'Cambiar Duración',
  'Change Sign Duration': 'Cambiar Duración de Firma',
  'Current Duration': 'Duración Actual',
  'New Sign Duration': 'Nueva Duración de Firma',
  'Update Duration': 'Actualizar Duración',
  'Duration updated successfully': 'Duración actualizada exitosamente',
  'Loading signature process': 'Cargando proceso de validación, espere un momento por favor...',
  'Select the documents to sign': 'Seleccione usos de la firma',
  Help: 'Ayuda',
  'Support phone': 'Soporte',
  'Agent phone': 'Teléfono de agente',
  'Validation Data': 'Validación de Datos Firma TuFacturero',

  // errors
  error: {
    unknown: 'Ha ocurrido un error desconocido, por favor intente nuevamente.',
    internal: 'Ha ocurrido un error interno, por favor intente nuevamente en unos minutos.',
  },
};

export const lang = 'es';
export const resources = {
  es: {
    translation: map,
  },
};
